import type { ButtonProps } from '@vtex/admin-ui'
import { Button, IconArrowLeft } from '@vtex/admin-ui'
import React from 'react'

import { TopbarMenuArea } from '../../../Instore/components/Header/Topbar'

export type AssemblyItemsTopbarProps = ButtonProps

export const AssemblyItemsTopbar = ({ ...props }: AssemblyItemsTopbarProps) => {
  return (
    <TopbarMenuArea>
      <Button {...props} variant="neutralTertiary" icon={<IconArrowLeft />} />
    </TopbarMenuArea>
  )
}
